export default "__VITE_ASSET__DEt2a0Nl__"